export default __webpack_public_path__ + "static/media/waiting2.d09e73a0.png";